var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSolution(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 113.65,
    height: 113.65,
    viewBox: "0 0 113.65 113.65",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ebene_1-2"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 56.82,
    cy: 56.82,
    r: 56.82,
    fill: "#f4a35c",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m80.31,43.87c.2,0,.39-.09.51-.26l1.67-2.23h2.57c.35,0,.64-.29.64-.64v-4.26c0-.35-.29-.64-.64-.64h-2.57l-1.67-2.23c-.12-.16-.31-.26-.51-.26h-1.81c-.18-1.91-1.79-3.4-3.74-3.4h-39.04c-2.07,0-3.76,1.69-3.76,3.76v46.21c0,2.07,1.69,3.76,3.76,3.76h39.04c1.95,0,3.56-1.5,3.74-3.4h1.81c.2,0,.39-.09.51-.26l1.67-2.23h2.57c.35,0,.64-.29.64-.64v-4.26c0-.35-.29-.64-.64-.64h-2.57l-1.67-2.23c-.12-.16-.31-.26-.51-.26h-1.8v-25.91h1.8Zm1.35-7c.12.16.31.26.51.26h2.25v2.98h-2.25c-.2,0-.39.09-.51.26l-1.67,2.23h-1.48v-7.95h1.48l1.67,2.23Zm-4.42,43.06c0,1.37-1.11,2.48-2.48,2.48h-39.04c-1.37,0-2.48-1.11-2.48-2.48v-46.21c0-1.37,1.11-2.48,2.48-2.48h39.04c1.37,0,2.48,1.11,2.48,2.48v46.21Zm2.75-8.87l1.67,2.23c.12.16.31.26.51.26h2.25v2.98h-2.25c-.2,0-.39.09-.51.26l-1.67,2.23h-1.48v-7.95h1.48Z",
    fill: "#dedede",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m41.32,35.77c-1.57,0-2.85,1.28-2.85,2.85v36.42c0,1.57,1.28,2.85,2.85,2.85s2.85-1.28,2.85-2.85v-36.42c0-1.57-1.28-2.85-2.85-2.85Zm1.57,39.26c0,.87-.7,1.57-1.57,1.57s-1.57-.7-1.57-1.57v-36.42c0-.87.7-1.57,1.57-1.57s1.57.7,1.57,1.57v36.42Z",
    fill: "#dedede",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m50.6,35.77c-1.57,0-2.85,1.28-2.85,2.85v36.42c0,1.57,1.28,2.85,2.85,2.85s2.85-1.28,2.85-2.85v-36.42c0-1.57-1.28-2.85-2.85-2.85Zm1.57,39.26c0,.87-.7,1.57-1.57,1.57s-1.57-.7-1.57-1.57v-36.42c0-.87.7-1.57,1.57-1.57s1.57.7,1.57,1.57v36.42Z",
    fill: "#dedede",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m59.87,35.77c-1.57,0-2.85,1.28-2.85,2.85v36.42c0,1.57,1.28,2.85,2.85,2.85s2.85-1.28,2.85-2.85v-36.42c0-1.57-1.28-2.85-2.85-2.85Zm1.57,39.26c0,.87-.7,1.57-1.57,1.57s-1.57-.7-1.57-1.57v-36.42c0-.87.7-1.57,1.57-1.57s1.57.7,1.57,1.57v36.42Z",
    fill: "#dedede",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m69.15,35.77c-1.57,0-2.85,1.28-2.85,2.85v36.42c0,1.57,1.28,2.85,2.85,2.85s2.85-1.28,2.85-2.85v-36.42c0-1.57-1.28-2.85-2.85-2.85Zm1.57,39.26c0,.87-.7,1.57-1.57,1.57s-1.57-.7-1.57-1.57v-36.42c0-.87.7-1.57,1.57-1.57s1.57.7,1.57,1.57v36.42Z",
    fill: "#dedede",
    strokeWidth: 0
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSolution);
export default __webpack_public_path__ + "static/media/solution.ccef7f707bb7cd0367f93c7d08dfd50f.svg";
export { ForwardRef as ReactComponent };